import React, { useEffect, useState } from "react";
import Joi from "joi-browser";
import http from "../../services/HttpService";
import config from "../../config.json";
import auth from "../../services/authService";
import useForm from "../../app/hooks/useForm";
import Select from "../../comman/select";
import TextArea from "../../comman/textarea";

const schema = {
  formId: Joi.string().required().label("Form"),
  formType: Joi.string().required().label("Form Type"),
  remarks: Joi.string().allow("").optional().label("Remarks"),
};

const defaultDocumentTypes = [
  { id: 1, name: "ACH Information" },
  { id: 2, name: "Insurance Information" },
  { id: 3, name: "Purchase Order" },
];

const AddFormLibrary = ({ handleAddFormLibrary, workflowTask, selectedForm }) => {
  const [forms, setForms] = useState([]);
  const [documentTypes, setDocumentTypes] = useState(defaultDocumentTypes);
  const [cannedMessages, setCannedMessages] = useState([]);
  const [submitting, setSubmitting] = useState(false);

  const doSubmit = async () => {
    setSubmitting(true);
    try {
      const user = auth.getCurrentUser();
      const wfTask = { ...workflowTask, performerId: user.id };
      const selectedLibraryForm = forms.find((x) => x.id === parseInt(stateData.formId));
      const frmData = new FormData();

      frmData.append("workflowTask", JSON.stringify(wfTask));
      frmData.append("formId", stateData.formId);
      frmData.append("formName", selectedLibraryForm?.formTitle || "");
      frmData.append("remarks", stateData.remarks || "");
      frmData.append("id", stateData.id || "");
      frmData.append("formType", stateData.formType || "");

      await http.post(config.AddFormLibrary, frmData);
      handleAddFormLibrary(true);
    } finally {
      setSubmitting(false);
    }
  };

  const {
    handleChange,
    handleSubmit,
    stateData,
    setStateData,
    stateErrors,
  } = useForm(schema, doSubmit);

  useEffect(() => {
    const loadFormLibraryOptions = async () => {
      const { data: formsResult } = await http.get(config.GetFormsByType + "Library Form");
      const { data: cannedMessagesResult } = await http.get(config.GetCodemanager + "Canned Message");
      const { data: documentTypesResult } = await http.get(config.GetCodemanager + "Document Type 2");
      const nextDocumentTypes = [...(documentTypesResult || [])];
      const lastItem = nextDocumentTypes[nextDocumentTypes.length - 1] || {};
      const lastId = lastItem.id || 0;
      const lastCode = lastItem.code || 0;

      nextDocumentTypes.push({
        id: lastId + 1,
        type: "Document Type 2",
        code: lastCode + 1,
        name: "Insurance Information",
      });
      nextDocumentTypes.push({
        id: lastId + 2,
        type: "Document Type 2",
        code: lastCode + 2,
        name: "ACH Information",
      });

      setForms(formsResult || []);
      setCannedMessages(cannedMessagesResult || []);
      setDocumentTypes(nextDocumentTypes.length > 0 ? nextDocumentTypes : defaultDocumentTypes);
    };

    loadFormLibraryOptions();
  }, []);

  useEffect(() => {
    if (selectedForm && selectedForm !== "") {
      setStateData({
        formId: selectedForm.formId || "",
        remarks: selectedForm.remarks || "",
        id: selectedForm.id || "",
        formType: selectedForm.formType || "",
      });
      return;
    }

    setStateData({
      remarks: "",
      formType: "",
      formId: "",
      id: "",
    });
  }, [selectedForm, setStateData]);

  const handleCannedMessage = ({ currentTarget }) => {
    setStateData((prevData) => ({ ...prevData, remarks: currentTarget.value }));
  };

  return (
    <div className="rt-add-form-container">
      <style>{`
        .rt-add-form-container {
          max-width: 100% !important;
          margin: 0 0 12px 0 !important;
          background: #ffffff;
          border: 1px solid #cbd5e1;
          border-radius: 0 !important;
          padding: 20px 24px;
          box-shadow: none !important;
        }
        .rt-add-form-header {
          margin-bottom: 16px;
          border-bottom: 1px solid #e2e8f0;
          padding-bottom: 12px;
        }
        .rt-add-form-header h2 {
          font-size: 16px !important;
          font-weight: 600 !important;
          color: #0f172a !important;
          margin: 0 0 4px 0 !important;
          display: flex;
          align-items: center;
          gap: 8px;
        }
        .rt-add-form-header p {
          font-size: 12.5px !important;
          color: #64748b !important;
          margin: 0 !important;
          line-height: 1.4;
        }
        .rt-add-form-container .form-control {
          border: 1px solid #cbd5e1 !important;
          border-radius: 0 !important;
          font-size: 13.5px !important;
          padding: 8px 12px !important;
          height: auto !important;
          color: #1e293b !important;
          background-color: #ffffff !important;
          box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04) !important;
          transition: all 0.2s ease !important;
        }
        .rt-add-form-container .form-control:focus {
          border-color: #2563eb !important;
          box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.12) !important;
          background-color: #ffffff !important;
        }
        .rt-add-form-container .wf-input-wrap .form-control,
        .rt-add-form-container .wf-input-wrap textarea,
        .rt-add-form-container .wf-input-withicon {
          padding: 8px 12px !important;
        }
        .rt-add-form-container .form-control-label,
        .rt-add-form-container label {
          font-size: 12px !important;
          font-weight: 700 !important;
          color: #334155 !important;
          margin-bottom: 6px !important;
          text-transform: uppercase !important;
          letter-spacing: 0.04em !important;
        }
        .rt-add-form-container .form-group {
          margin-bottom: 20px !important;
        }
        .rt-add-form-container .form-group.required .form-control-label::after,
        .rt-add-form-container .form-group.required label::after {
          content: " *" !important;
          color: #ef4444 !important;
          font-weight: bold !important;
        }
        .rt-add-form-container textarea.form-control {
          min-height: 100px !important;
          resize: vertical !important;
        }
        .rt-add-form-container .btn-save-form {
          display: inline-flex !important;
          align-items: center !important;
          justify-content: center !important;
          gap: 8px !important;
          background: #2563eb !important;
          color: #ffffff !important;
          border: 1px solid #2563eb !important;
          padding: 7px 18px !important;
          border-radius: 0 !important;
          font-size: 13.5px !important;
          font-weight: 500 !important;
          cursor: pointer !important;
          transition: all 0.2s ease !important;
          outline: none !important;
          box-shadow: 0 2px 5px rgba(37, 99, 235, 0.2) !important;
        }
        .rt-add-form-container .btn-save-form:hover {
          background: #1d4ed8 !important;
          border-color: #1d4ed8 !important;
          transform: translateY(-1px) !important;
          box-shadow: 0 4px 12px rgba(37, 99, 235, 0.3) !important;
        }
        .rt-add-form-container .btn-save-form:active {
          transform: translateY(0) !important;
        }
        .rt-add-form-container .btn-cancel-form {
          display: inline-flex !important;
          align-items: center !important;
          justify-content: center !important;
          gap: 8px !important;
          background: #ffffff !important;
          color: #1e293b !important;
          border: 1px solid #cbd5e1 !important;
          padding: 7px 18px !important;
          border-radius: 0 !important;
          font-size: 13.5px !important;
          font-weight: 500 !important;
          cursor: pointer !important;
          transition: all 0.2s ease !important;
          outline: none !important;
          box-shadow: 0 2px 5px rgba(15, 23, 42, 0.06) !important;
        }
        .rt-add-form-container .btn-cancel-form:hover {
          background: #f8fafc !important;
          color: #0f172a !important;
          border-color: #94a3b8 !important;
          transform: translateY(-1px) !important;
        }
        .rt-add-form-container .btn-cancel-form:active {
          transform: translateY(0) !important;
        }
        .rt-add-form-container .btn-save-form:disabled,
        .rt-add-form-container .btn-cancel-form:disabled {
          background: #cbd5e1 !important;
          border-color: #cbd5e1 !important;
          color: #94a3b8 !important;
          opacity: 0.85 !important;
          cursor: not-allowed !important;
          transform: none !important;
          box-shadow: none !important;
        }
        .rt-add-form-container .text-danger,
        .rt-add-form-container .alert-danger {
          font-size: 11.5px !important;
          color: #ef4444 !important;
          margin-top: 5px !important;
          font-weight: 500 !important;
          background: none !important;
          border: none !important;
          padding: 0 !important;
          display: block !important;
        }
      `}</style>
      <div className="rt-add-form-header">
        <h2>
          <i className={`fa ${stateData.id ? "fa-pencil-square-o" : "fa-paper-plane"}`} aria-hidden="true"></i>
          {stateData.id ? "Edit Form Request" : "Send Form to Applicant"}
        </h2>
        <p>
          {stateData.id
            ? "Update the configuration for this form request."
            : "Select a form template and form type to request from the applicant, with optional custom remarks."}
        </p>
      </div>
      <div className="row">
        <div className="col-md-6">
          <Select
            name="formId"
            label="Select the form to send to the applicant"
            options={forms}
            optName="formTitle"
            optValue="id"
            value={stateData.formId || ""}
            onChange={handleChange}
            error={stateErrors.formId}
            req={schema.formId}
          />
        </div>
        <div className="col-md-6">
          <Select
            name="formType"
            label="Form Type"
            options={documentTypes}
            optName="name"
            optValue="name"
            value={stateData.formType || ""}
            onChange={handleChange}
            error={stateErrors.formType}
            req={schema.formType}
          />
        </div>
        <div className="col-md-12">
          <div className="form-group">
            <label htmlFor="cannedMessage" className="form-control-label">
              Select Default Message
            </label>
            <select
              name="cannedMessage"
              id="cannedMessage"
              className="form-control"
              onChange={handleCannedMessage}
              value={stateData.remarks || ""}
            >
              <option value="">Select</option>
              {cannedMessages.map((item) => (
                <option key={item.id} value={item.name}>{item.name}</option>
              ))}
            </select>
          </div>
        </div>
        <div className="col-md-12">
          <TextArea
            name="remarks"
            label="Remarks"
            value={stateData.remarks || ""}
            onChange={handleChange}
            error={stateErrors.remarks}
            req={schema.remarks}
          />
        </div>
        <div className="col-md-12 text-center" style={{ marginTop: "24px", display: "flex", gap: "12px", justifyContent: "center" }}>
          <button className="btn-cancel-form" type="button" onClick={() => handleAddFormLibrary(false)} disabled={submitting}>
            <i className="fa fa-arrow-left" aria-hidden="true"></i> Back to Forms
          </button>
          <button className="btn-save-form" type="button" onClick={handleSubmit} disabled={submitting}>
            {submitting ? (
              <><i className="fa fa-spinner fa-spin" aria-hidden="true"></i> {stateData.id ? "Updating..." : "Sending..."}</>
            ) : (
              <><i className="fa fa-paper-plane" aria-hidden="true"></i> {stateData.id ? "Update Request" : "Send Request"}</>
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default AddFormLibrary;
